function hasExplicitOffset(t: string): boolean {
  return /[zZ]$/.test(t) || /[+-]\d{2}(:\d{2})?$/.test(t);
}

/** Parse API/DB instants; timezone-less strings are UTC (Postgres timestamptz). */
export function parseApiInstant(raw: string | null | undefined): Date | null {
  if (!raw) return null;
  const t = raw.trim();
  if (!t) return null;
  if (hasExplicitOffset(t)) {
    const ms = Date.parse(t);
    return Number.isNaN(ms) ? null : new Date(ms);
  }
  const normalized = t.includes(" ") ? t.replace(" ", "T") : t;
  const ms = Date.parse(`${normalized}Z`);
  return Number.isNaN(ms) ? null : new Date(ms);
}
